const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }
const breadcrumbsClientes = { name: 'Clientes', pathName: null, action: 'clientes' }

export default [
  {
    path: '/v3/clientes',
    name: 'Clientes',
    component: () => import('@/views/BaseRoutingComponent.vue'),
    children: [
      {
        path: 'consultar-ofertas',
        name: 'consultar-ofertas',
        component: () => import('@/modules/clientes/consultar-ofertas/views/pages/ConsultarOfertas.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClientes,
            {
              name: 'Consultar Benefícios',
              pathName: null,
            },
          ],
          title: 'Consultar Benefícios',
          requiredUserPermissions: ['clientes/consultar-ofertas'],
          allowOnlyMercapromo: true,
        },
      },
    ],
  },
]
